/** Little-endian cursor over a byte buffer, with the replay's varints. */
export class ByteReader {
  private view: DataView;
  at = 0;

  constructor(readonly bytes: Uint8Array) {
    this.view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
  }

  get done(): boolean {
    return this.at >= this.bytes.length;
  }

  u8(): number {
    return this.bytes[this.at++];
  }

  u16(): number {
    const v = this.view.getUint16(this.at, true);
    this.at += 2;
    return v;
  }

  u32(): number {
    const v = this.view.getUint32(this.at, true);
    this.at += 4;
    return v;
  }

  /** Unsigned LEB128. Values above 2^53 lose precision; use `varBig` for keys. */
  var(): number {
    let v = 0;
    let scale = 1;
    for (;;) {
      const b = this.bytes[this.at++];
      v += (b & 0x7f) * scale;
      if (b < 0x80) return v;
      scale *= 128;
    }
  }

  varBig(): bigint {
    let v = 0n;
    let shift = 0n;
    for (;;) {
      const b = this.bytes[this.at++];
      v |= BigInt(b & 0x7f) << shift;
      if (b < 0x80) return v;
      shift += 7n;
    }
  }

  /** Zigzag signed varint (safe for |v| < 2^52). */
  svar(): number {
    const v = this.var();
    return v % 2 === 0 ? v / 2 : -(v + 1) / 2;
  }

  /** Zigzag signed varint as a 64-bit two's-complement delta. */
  svarBig(): bigint {
    const v = this.varBig();
    return BigInt.asUintN(64, (v >> 1n) ^ -(v & 1n));
  }

  /** Ascending id list stored as gaps. */
  ids(): Uint32Array {
    const n = this.var();
    const out = new Uint32Array(n);
    let prev = -1;
    for (let i = 0; i < n; i++) {
      prev += this.var() + 1;
      out[i] = prev;
    }
    return out;
  }
}
